export default {
  en: {
    btnClose: 'Close',
    connect: 'Connect',
    btnShowLog: 'CLI output',
    table: {
      configReg: 'Configuration register',
      hostname: 'Hostname',
      image: 'Image',
      loginIp: 'Login IP',
      loginType: 'Management protocol',
      memoryUtilization: 'Memory %',
      model: 'Model',
      platform: 'Platform',
      processor: 'Processor',
      rd: 'Routing domain',
      reload: 'Reload reason',
      siteName: 'Site',
      slug: 'API Slug',
      sn: 'Serial number',
      stpDomain: 'Switching domain',
      uptime: 'Uptime',
      vendorFamily: 'Vendor family',
      version: 'Version',
    },
  },
};
